import { Calculation } from 'final-form-calculate'
import { MetaPath } from 'util/metaPath'
import { EscutaInicialState } from 'view/atendimentos/escuta-inicial/model'

import { AgendarConsultaPanelModel } from '../components/AgendarConsultaPanel'

export const createAgendarConsultaCalculations = (name: MetaPath<AgendarConsultaPanelModel>): Calculation[] => [
  {
    field: name.lotacao.absolutePath(),
    updates: {
      [name.data.absolutePath()]: (lotacaoValue: string, allValues: EscutaInicialState) =>
        lotacaoValue && allValues.agendarConsulta.data,
      [name.horario.absolutePath()]: (lotacaoValue: string, allValues: EscutaInicialState) =>
        lotacaoValue && allValues.agendarConsulta.horario,
    },
  },
  {
    field: name.data.absolutePath(),
    updates: {
      [name.horario.absolutePath()]: (dataValue: string, allValues: EscutaInicialState) =>
        dataValue && allValues.agendarConsulta.horario,
    },
  },
]
